function getTax(taxableIncome) {
    if (taxableIncome <= 18200)
        return {
            income: taxableIncome,
            tax: 0,
            category: 1,
            marginalTaxRate: 0,
            init: function () {
                this.incomeAfterTax = this.income - this.tax;
                return this;
            }
        }.init();
    else if (taxableIncome <= 37000)
        return {
            income: taxableIncome,
            tax: (taxableIncome - 18200) * 0.19,
            category: 1,
            marginalTaxRate: 19,
            init: function () {
                this.incomeAfterTax = this.income - this.tax;
                return this;
            }
        }.init();

    else if (taxableIncome <= 90000)
        return {
            income: taxableIncome,
            tax: 3572 + (taxableIncome - 37000) * 0.325,
            category: 2,
            marginalTaxRate: 32.5,
            init: function () {
                this.incomeAfterTax = this.income - this.tax;
                return this;
            }
        }.init();
    else if (taxableIncome <= 180000)
        return {
            income: taxableIncome,
            tax: 20797 + (taxableIncome - 90000) * 0.37,
            category: 3,
            marginalTaxRate: 37,
            init: function () {
                this.incomeAfterTax = this.income - this.tax;
                return this;
            }
        }.init();
    else
        return {
            income: taxableIncome,
            tax: 54097 + (taxableIncome - 180000) * 0.45,
            category: 4,
            marginalTaxRate: 45,
            init: function () {
                this.incomeAfterTax = this.income - this.tax;
                return this;
            }
        }.init();
}

export default getTax;
